import dynamic from 'next/dynamic';

import clsx from 'clsx';

import { routes } from '@hultafors/hultaforsgroup/config';
import {
  ArticleListItem,
  ImageLoadFragment,
  isReportListing,
} from '@hultafors/hultaforsgroup/types';

import DocumentSvg from '../../svg/document.svg';
import ImagePlaceholder from '../image-placeholder/image-placeholder';
import styles from './article-item.module.scss';

const DatoImage = dynamic(() =>
  import('@hultafors/shared/components').then((module) => module.DatoImage),
);

const Link = dynamic(() =>
  import('@hultafors/shared/components').then((module) => module.SharedLink),
);

const HTag = dynamic(() =>
  import('@hultafors/shared/components').then((mod) => mod.HTag),
);

interface ArticleItemProps {
  asThumbnail?: boolean;
  image?: ImageLoadFragment | null;
  item: ArticleListItem;
}

export const ArticleItem: React.FC<ArticleItemProps> = ({
  asThumbnail,
  image,
  item,
}) => {
  const { category, country, publishDate, slug, title } = item;
  const isReport = isReportListing(item);

  const href = isReport && item.pdf ? item.pdf.url : `/${routes.news}/${slug}`;

  return (
    <article
      className={clsx(
        styles['article-item'],
        asThumbnail && styles['thumbnail'],
      )}
    >
      <Link href={href} isWrapper>
        {image && asThumbnail && (
          <DatoImage aspectRatio={4 / 3} image={image} />
        )}
        {!image && asThumbnail && <ImagePlaceholder />}
        <HTag styleType="sub-heading" type="p">{`${publishDate} - ${category}${
          country ? ` - ${country}` : ''
        } `}</HTag>

        <HTag className={styles['title']} styleType="p2-paragraph" type="h3">
          {isReport && (
            <DocumentSvg aria-hidden={true} height={20} width={20} />
          )}
          {title}
        </HTag>
      </Link>
    </article>
  );
};
